import type { SVGProps } from 'react';
const SvgLaptopChromebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#laptop_chromebook_svg__a)">
      <path
        fill="currentColor"
        d="M22 18V3H2v15H0v2h24v-2h-2Zm-8 0h-4v-1h4v1Zm6-3H4V5h16v10Z"
      />
    </g>
    <defs>
      <clipPath id="laptop_chromebook_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLaptopChromebook;
